import { useState } from 'react';
import AuthModal from '../../../components/feature/AuthModal';
import DemoModal from '../../../components/feature/DemoModal';

export default function CTA() {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);

  return (
    <>
      <section className="py-24 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 relative overflow-hidden">
        <div className="max-w-5xl mx-auto">
          <div 
            className="relative rounded-3xl overflow-hidden border border-gray-800"
            style={{
              backgroundImage: `url('https://public.readdy.ai/ai/img_res/e5d0b653ba75845b44a6111d2b12bcef.jpg')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-r from-gray-950/95 to-gray-900/95"></div>
            
            <div className="relative px-8 lg:px-16 py-20 text-center">
              <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
                Ready to Transform Your Data?
              </h2>
              <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto">
                Join thousands of companies making smarter decisions with real-time analytics. Start your free trial today.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                <button 
                  onClick={() => setIsAuthModalOpen(true)}
                  className="px-8 py-4 bg-teal-500 text-gray-900 rounded-lg font-semibold hover:bg-teal-400 transition-all cursor-pointer whitespace-nowrap shadow-xl"
                >
                  Start Free Trial
                </button>
                <button 
                  onClick={() => setIsDemoModalOpen(true)}
                  className="px-8 py-4 bg-transparent text-white rounded-lg font-semibold border-2 border-gray-600 hover:bg-gray-800/50 transition-all cursor-pointer whitespace-nowrap"
                >
                  Schedule Demo
                </button>
              </div>

              <div className="flex items-center justify-center gap-8 mt-10 flex-wrap">
                <div className="flex items-center gap-2 text-gray-300">
                  <i className="ri-check-line text-xl text-teal-400"></i>
                  <span>Free 14-day trial</span>
                </div>
                <div className="flex items-center gap-2 text-gray-300">
                  <i className="ri-check-line text-xl text-teal-400"></i>
                  <span>No credit card required</span>
                </div>
                <div className="flex items-center gap-2 text-gray-300">
                  <i className="ri-check-line text-xl text-teal-400"></i>
                  <span>Cancel anytime</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {isAuthModalOpen && (
        <AuthModal 
          isOpen={isAuthModalOpen} 
          onClose={() => setIsAuthModalOpen(false)}
          initialMode="signup"
        />
      )}

      {isDemoModalOpen && (
        <DemoModal 
          isOpen={isDemoModalOpen} 
          onClose={() => setIsDemoModalOpen(false)}
        />
      )}
    </>
  );
}